import React from 'react';
import styled from 'styled-components/macro';
import { THEME_COLORS } from '../utils/theme';
import { HeaderFont } from './styles';

const BannerContainer = styled.div`
  text-align: center;
  background-color: ${THEME_COLORS.brandPink};
`;

const BannerTitle = styled(HeaderFont)`
  padding: 30px 0;
  display: block;
  font-size: 30px;
  color: #ffffff;
`;

interface Props {
  year: string;
  // tagline: string;
}

export const YearBanner: React.FC<Props> = props => {
  return (
    <BannerContainer>
      <BannerTitle>DubHacks {props.year}</BannerTitle>
    </BannerContainer>
  );
};
